<template>
  <div class="box" v-loading="loading">
    <div class="result-box" v-if="result==='fail'">
      <img class="img2" src="../../assets/002.png" alt="" />
      <p>{{errorMessage}}</p>
    </div>
  </div>
</template>

<script>
import config from '../../config';
export default {
  data() {
    return {
      errorMessage: "",
      loading: false,
      result: ''
    };
  },
  mounted() {
    console.log(this.$route.query);
    let { userId, orderNo, name, idNo } = this.$route.query;
    localStorage.setItem('orderNo', orderNo);
    if (userId && orderNo && name && idNo) {
      this.loading = true;
      this.$api
        .authFaceH5({
          userId,
          orderNo,
          name,
          idNo: window.atob(idNo),
        })
        .then((res) => {
          if (res.data.code == "200") {
            let host = window.location.host;
            let callbackUrl = encodeURIComponent(`http://${host}/#/auth/result`);
            window.location.href = `${res.data.data.url}&url=${callbackUrl}`;
            console.log(`${res.data.data.url}&url=${callbackUrl}`)
          } else {
            this.errorMessage = res.data.msg;
            this.result = 'fail';
          }
        }).finally(() => {
          this.loading = false;
        });
    } else {
      this.loading = false;
      this.errorMessage = "缺少参数";
    }
  },
  methods: {},
};
</script>

<style lang='less' scoped>
// @import '../../style/loading.css';
@import "../../style/mixin.less";
.box {
  width: 100%;
  .result-box{
    .flex(flex-start,column);
    padding-top: 100px;
    padding-bottom: 200px;
    img{
      width: 80px;
    }
    p{
      margin-top: 10px;
    }
  }
}
</style>